module.exports = __webpack_public_path__ + "img/japanese_1.6cc50fc0.png";